import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

// Import utilities
import { openNotification } from 'components/utilities/notification/notification';

// Import helpers
import { sendPrePaymentMail } from 'helpers/configurator';

export const usePrePaymentMail = () => {
	const { t } = useTranslation('configurator');

	return useMutation({
		mutationFn: sendPrePaymentMail,
		onSuccess: () =>
			openNotification({
				type: 'success',
				title: t('notification_success_title'),
				description: t('notification_success_offer_email')
			}),
		onError: () =>
			openNotification({
				type: 'error',
				title: t('notification_error_title'),
				description: t('notification_error_offer_email')
			})
	});
};